<template>
  <mobile-dialog title="温馨提示" :visible.sync="dialogVisible" @close="close" @confirm="close">
    <template #content>
      <div class="tips">
        <span>{{ tips }}</span>
      </div>
    </template>
  </mobile-dialog>
</template>

<script>
import MobileDialog from '../dialog/Index.vue'

import { mapMutations } from 'vuex'

export default {
  name: 'MobileTipsDialog',
  components: {
    MobileDialog,
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  computed: {
    visible() {
      return this.$store.getters.tipsDialogVisible
    },
    tips() {
      return this.$store.getters.tips
    }
  },
  watch: {
    visible: function (val) {
      this.dialogVisible = val
    }
  },
  methods: {
    ...mapMutations(['setTipsDialog']),
    close() {
      this.setTipsDialog({ visible: false })
    },
  }
}
</script>

<style lang="scss" scoped>
.tips {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vw;
  font-size: 4vw;
}
</style>